/**
 * 作品集媒體工具。
 *
 * 資料結構：portfolio.imageUrls: string[]，並有一個「同序」的可選欄位
 * portfolio.mediaTypes: ('image' | 'video')[]。
 *
 * 注意：B2 上的檔案 key 曾經被存成「沒有副檔名」，所以副檔名推斷只能當作
 * 舊資料的 fallback，mediaTypes 才是可信來源。
 */

const VIDEO_EXT_RE = /\.(mp4|m4v|mov|webm|ogv|3gp|mkv|avi)(\?|#|$)/i

export function isPortfolioVideoUrl(url) {
  return !!url && VIDEO_EXT_RE.test(String(url))
}

/**
 * @returns {{ url: string, type: 'image' | 'video' }[]}
 */
export function getPortfolioMediaList(portfolio) {
  const raw = portfolio?.imageUrls
  const urls = Array.isArray(raw) ? raw : raw ? [raw] : []
  const types = portfolio?.mediaTypes
  return urls
    .filter(Boolean)
    .map((url, i) => ({
      url,
      type: types?.[i] || (isPortfolioVideoUrl(url) ? 'video' : 'image')
    }))
}

/**
 * 取列表縮圖用的媒體：優先挑第一張「圖片」，沒有圖片才回傳第一個影片。
 * 用在爬蟲 / OG 圖 / 不支援 <video> 的清單，避免出現破圖。
 */
export function getPortfolioThumb(portfolio) {
  const list = getPortfolioMediaList(portfolio)
  return list.find((m) => m.type === 'image') || list[0] || null
}

/**
 * 影片縮圖用：加上 #t=0.1 讓 Safari / iOS 願意畫出第一個影格，
 * 否則 preload="metadata" 常常只顯示黑框。
 */
export function withPosterFrame(url) {
  if (!url) return url
  return url.includes('#') ? url : `${url}#t=0.1`
}
